import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import { checkStringQuestionMark } from 'ui-component-library/utils/helpers'

import HeadlineThree from '../../00-Primitives/Headlines/HeadlineThree'
import Ruler from '../../00-Primitives/Ruler'
import TextBlock from '../../00-Primitives/TextBlock'
import MoreLessToggle from '../../00-Primitives/MoreLessToggle'
import style from './style.scss'

export type Props = {
  className?: string
  headlineText: string
  lessText: string
  moreText: string
  questionText: string
  rulerClass?: string
}

FAQDetail.defaultProps = {
  className: '',
  rulerClass: '',
}

function isOverflow(element: HTMLDivElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  )
}

function FAQDetail(props: Props) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [hasMoreOrLess, setMoreOrLess] = useState(false)
  const faqRef = useRef<HTMLDivElement | null>(null)

  const {
    className,
    headlineText,
    lessText,
    moreText,
    questionText,
    rulerClass,
  } = props
  const formattedHeadline = checkStringQuestionMark(headlineText)
  const expandText = isExpanded ? lessText : moreText

  useEffect(() => {
    if (faqRef.current && isOverflow(faqRef.current)) {
      setMoreOrLess(true)
    }
  }, [faqRef])

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={classNames(style.wrapper, className)}>
      <div
        ref={faqRef}
        className={classNames(style.overflowWrapper, {
          [style.expanded]: isExpanded,
        })}
      >
        <HeadlineThree>{formattedHeadline}</HeadlineThree>
        <TextBlock className={style.question}>{questionText}</TextBlock>
        <Ruler className={rulerClass} kind='thin-light-gray' />
      </div>
      <div
        className={classNames(style.moreLessContainer, {
          [style.addHeight]: !hasMoreOrLess,
        })}
      >
        {hasMoreOrLess && (
          <MoreLessToggle
            expandText={expandText}
            isExpanded={isExpanded}
            onToggle={handleToggleExpanded}
          />
        )}
      </div>
    </div>
  )
}

export default FAQDetail
